import React from "react";
import "./CircleScrollBiswa.css";
import {
  FaGithub,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaWhatsapp,
  FaHackerrank,
} from "react-icons/fa";

const CircleScrollBiswa = ({ devImg }) => {
  return (
    <div className="biswa__menuContainer">
      <nav className="biswa__menu">
        <input
          type="checkbox"
          href="#"
          name="biswa__menu-open"
          id="biswa__menu-open"
          className="biswa__menu-open"
        />
        <label className="biswa__menu-open-button" for="biswa__menu-open">
          <img className="devImage" src={devImg} alt="" />
        </label>
        <a href="#" className="biswa__menu-item blue">
          <FaFacebook />
        </a>
        <a href="#" className="biswa__menu-item green">
          <FaWhatsapp />
        </a>
        <a href="#" className="biswa__menu-item red">
          <i className="fa fa-heart">
            <FaInstagram />
          </i>
        </a>
        <a href="#" className="biswa__menu-item black">
          <i className="fa fa-microphone">
            <FaGithub />
          </i>
        </a>
        <a href="#" className="biswa__menu-item lightgreen">
          <i className="fa fa-star">
            <FaHackerrank />
          </i>
        </a>
        <a href="#" className="biswa__menu-item lightblue">
          <i className="fa fa-diamond">
            <FaLinkedin />
          </i>
        </a>
      </nav>
    </div>
  );
};

export default CircleScrollBiswa;
